var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyright(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copyright"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0C6.33555 0 7.59117 0.520098 8.53555 1.46447C9.47992 2.40885 10 3.66445 10 5C10 6.33555 9.47992 7.59115 8.53553 8.53555C7.59115 9.47992 6.33555 10 5 10C3.66445 10 2.40885 9.47992 1.46445 8.53555C0.520098 7.59117 0 6.33555 0 5C0 3.66445 0.520098 2.40885 1.46445 1.46445C2.40885 0.520078 3.66445 0 5 0ZM0.585938 5C0.585938 7.43393 2.56607 9.41406 5 9.41406C7.43393 9.41406 9.41406 7.43393 9.41406 5C9.41406 2.56607 7.43393 0.585938 5 0.585938C2.56607 0.585938 0.585938 2.56607 0.585938 5Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8276 3.13574C4.68214 3.0745 4.51274 3.13845 4.44919 3.27852C4.12727 3.98804 3.39984 4.44649 2.596 4.44649C1.48147 4.44649 0.574745 3.5733 0.574745 2.5C0.574745 1.4267 1.48147 0.553506 2.596 0.553506C3.39521 0.553506 4.12094 1.00828 4.44486 1.7121C4.50918 1.85185 4.67892 1.91496 4.82403 1.85299C4.96914 1.79107 5.03465 1.62758 4.97033 1.48784C4.55437 0.584004 3.62239 0 2.59602 0C1.16457 0 0 1.12149 0 2.5C0 3.87851 1.16457 5 2.59602 5C3.62831 5 4.56248 4.41127 4.97589 3.50015C5.03944 3.36009 4.97305 3.19694 4.8276 3.13574Z",
    transform: "translate(2.5 2.5)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.ba9cfc50670259cf9bf2d949de0a0ddd.svg";
export { ForwardRef as ReactComponent };